import React from 'react'
import optimizedWindowResize from '../../common/lib/optimized-window-resize'

export default (Component, positionProps) => {
  return (
    class WithPositionFixed extends React.Component {
      constructor(props) {
        super(props)

        this.contents = React.createRef()

        this.state = {
          height: '0',
          width: '0',
        }

        this.setHeightWidth = this.setHeightWidth.bind(this)
      }

      setHeightWidth() {
        const pixelAspectRatio = window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
        const contents = this.contents.current

        const height = contents.offsetHeight
        const width = (contents.offsetWidth / pixelAspectRatio)

        const unit = 'px'

        this.setState({
          height: `${height}${unit}`,
          width: `${width}${unit}`,
        })
      }

      componentDidMount() {
        this.setHeightWidth()

        optimizedWindowResize.add('updateHeightWidth', () => {
          this.setHeightWidth()
        })
      }

      componentWillUnmount() {
        optimizedWindowResize.remove('updateHeightWidth')
      }

      render() {
        let styles = {
          contents: {
            position: 'fixed',
          },
          dimensions: {
            height: this.state.height,
            width: this.state.width,
          }
        }

        if (positionProps) {
          styles.contents = Object.assign(styles.contents, positionProps)
        }

        return (
          <div className="pos(f)">
            <div className="pos(f)__contents" ref={this.contents} style={styles.contents}>
              <Component {...this.props} />
            </div>
            <div className="pos(f)__dimensions" style={styles.dimensions} />
          </div>
        )
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/common/components/with-position-fixed.js